import { useEffect } from "react";
import * as CookieConsent from "vanilla-cookieconsent";

import { buildCookieConsentConfig } from "./config/cookie-consent.config";
// oxlint-disable-next-line import/no-unassigned-import
import "vanilla-cookieconsent/dist/cookieconsent.css";
// oxlint-disable-next-line import/no-unassigned-import
import "./cookie-consent.css";

/**
 * Headless root mount for cookie consent, injected into the base template's
 * `Providers` wrapper by the `providers` codemod. Mounting it boots
 * vanilla-cookieconsent: the banner appears on every route, sign-in pages
 * included, until the visitor decides, and stays gone once consent is stored
 * in the `cc_cookie` first-party cookie. `run` is idempotent, so remounts are
 * safe. Renders nothing; the library manages its own DOM under `#cc-main`.
 */
export function CookieConsentProvider() {
  useEffect(() => {
    void CookieConsent.run(buildCookieConsentConfig());
  }, []);

  return null;
}
